function mergeSum(items) {
  return items?.reduce((prev, item) => {
    Object.entries(item).forEach(([key, value]) => {
      if (typeof value === "number" && !isNaN(value)) {
        if (prev[key]) {
          prev[key] += value
        } else {
          prev[key] = value
        }
      }
    })
    return prev
  }, {})
}

export default mergeSum
